export default __webpack_public_path__ + "static/media/apples.d0b732d9.webp";